// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  province_id: number
  province_name: string
}

export function useProvinceById(): {
  data: Type | null
  isLoading: boolean
  fetchData: (province_id: number | string) => void
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchData = (province_id: number | string) => {
    setLoading(true)

    api.get(
      "/provinces/byid",
      { params: { province_id } }
    ).then((res: SuccessFetch<{
      payload: Type
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, fetchData }
}